import { Link } from '@mui/material';

import { GDMLinkComponent } from './GDMLink.type';

/* TODO: Implement component using GDM default design */
const GDMLink: GDMLinkComponent = props => <Link {...props} />;

export default GDMLink;
